import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTimeMostOfTheTimeGlyphSecondary from './svgs/TimeMostOfTheTimeGlyphSecondary.js';
import SvgTimeMostOfTheTimeGlyph from './svgs/TimeMostOfTheTimeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var timeMostOfTheTimeGlyph = (props => useIcon(SvgTimeMostOfTheTimeGlyph, SvgTimeMostOfTheTimeGlyphSecondary, props));

export { timeMostOfTheTimeGlyph as default };
